import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import LanguageContext from '../../context/LanguageContext.js';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    const { dir } = useContext(LanguageContext);
    const { t } = useTranslation();

    return (
      <main className='main'>
            <Breadcrumb page={t('breadcrumb.privacyPolicy')} />
            <section className="section privacy-policy" dir={dir()}>
            <div className="container">
                <h1 className="section-title">{t('privacyPolicy.title')}</h1>
                <p className="privacy-policy-last-updated">{t('privacyPolicy.lastUpdated')}</p>
                
                <div className="privacy-policy-content">
                    <h2>{t('privacyPolicy.introduction')}</h2>
                    
                    <h3>{t('privacyPolicy.informationWeCollect')}</h3>
                    <p>{t('privacyPolicy.personalInformation')}</p>
                    <p>{t('privacyPolicy.usageInformation')}</p>
                    
                    <h3>{t('privacyPolicy.howWeUse')}</h3>
                    <p>{t('privacyPolicy.useDescription')}</p>
                    
                    <h3>{t('privacyPolicy.sharing')}</h3>
                    <p>{t('privacyPolicy.sharingDescription')}</p>
                    
                    <h3>{t('privacyPolicy.dataSecurity')}</h3>
                    <p>{t('privacyPolicy.securityDescription')}</p>
                    
                    <h3>{t('privacyPolicy.yourRights')}</h3>
                    <p>{t('privacyPolicy.rightsDescription')}</p>
                    
                    <h3>{t('privacyPolicy.cookies')}</h3>
                    <p>{t('privacyPolicy.cookiesDescription')}</p>
                    
                    <h3>{t('privacyPolicy.thirdPartyLinks')}</h3>
                    <p>{t('privacyPolicy.thirdPartyDescription')}</p>
                    
                    <h3>{t('privacyPolicy.childrensPrivacy')}</h3>
                    <p>{t('privacyPolicy.childrensDescription')}</p>
                    
                    <h3>{t('privacyPolicy.changesToPolicy')}</h3>
                    <p>{t('privacyPolicy.changesDescription')}</p>
                    
                    <h3>{t('privacyPolicy.contactUs')}</h3>
                    <p>{t('privacyPolicy.contactDescription')}</p>
                </div>
            </div>
        </section>
      </main>
        
    );
};

export default PrivacyPolicy;